<template>
<div id="grid">


  <div class="scroll"><div class="grid">
      <game theme="wph games art" vid="/assets/videos/wph.mp4" logo="/assets/images/wphlogo.png" path="/workplacehazards"></game>
    <game theme="ss games art writing" photo="/assets/images/scorched.png" logo="/assets/images/scorchedlabel.png" path="/scorchedstatesman"></game>
    <game theme="hiu games art writing" photo="/assets/images/hell.png" logo="/assets/images/helllabel.png" path="/hellisunderground"></game>
    <game theme="sp games writing" photo="/assets/images/scarlet.png" logo="/assets/images/scarletLabel.PNG" path="/scarletpimpernel"></game>
    <game theme="ht gf games art writing" photo="/assets/images/sEOAB7f.png" logo="https://img.itch.zone/aW1nLzE5OTkxODkucG5n/315x250%23c/WNhS3N.png" path="/godsforsaken"></game>
    <game theme="rotc games writing art" photo="/assets/images/rotc.png" logo="https://img.itch.zone/aW1nLzE4MzY2NDIucG5n/347x500/owqsNC.png" path="/riseofthecurrent"></game>
    <game theme="kt games" photo="/assets/images/koala.png" logo="/assets/images/koalatealabel.png" path="/koalatea"></game>
    <game theme="ht so games art" photo="/assets/images/standoff.jpg" logo="/assets/images/standofflabel.png" path="/standoff"></game>
    <game theme="ht fot games art" photo="/assets/images/1403.png" logo="/assets/images/1403l.png" path="/1403"></game>
    <game theme="ht dcc games art" vid="/assets/videos/DCC.mp4" logo="/assets/images/donut.png" path="/donutcountyclone"></game>
    <game theme="ht nca games art writing" photo="https://img.itch.zone/aW1nLzE2MzUwMDMucG5n/315x250%23c/RaPThr.png" name="Nameless Chat App" path="/namelesschatapp"></game>
    <game theme="site art" photo="/assets/images/site.png" name="Portfolio Site" path="/site"></game>
    <!--<game theme="ht fo games art writing" photo="https://img.itch.zone/aW1nLzE2MzUzNDYucG5n/315x250%23c/adbYer.png" logo="/assets/images/koalatealabel.png" path="/farout"></game> -->
    <game theme="ht sts games art" photo="/assets/images/studioslaughter.jpg" logo="/assets/images/studiolabel.png" path="/studioslaughter"></game>
    <!--<game theme="screen film writing" photo="/assets/images/screenplay.jpg" name="Screenplays" path="/screenplays"></game>-->
    <!--<game theme="more games art writing" photo="/assets/images/more.png" name="Miscellaneous Projects" path="/more"></game>-->

  </div>
</div>
</div>
</template>

<script>
import Isotope from "isotope-layout/dist/isotope.pkgd"
import game from './game.vue'



var iso;

export default {
  name: "grid",
  components: {
    game
  },
  mounted: function () {
    document.getElementById("sortbutton").classList.remove("hide");
    this.$nextTick(init());
  },
  beforeRouteLeave:function(to, from, next){
    console.log("fired before route leave");
    document.getElementById("sortbutton").classList.add("hide");
    next();
  }
  ,
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}

function init () {
  iso = new Isotope('.grid', {
    itemSelector: '.element-item',
    layoutMode: 'fitRows'
  });

// filter functions
  var filterFns = {
    // show if number is greater than 50
    numberGreaterThan50: function( itemElem ) {
      var number = itemElem.querySelector('.number').textContent;
      return parseInt( number, 10 ) > 50;
    },
    // show if name ends with -ium
    ium: function( itemElem ) {
      var name = itemElem.querySelector('.name').textContent;
      return name.match( /ium$/ );
    }
  };

// bind filter button click
  var filtersElem = document.querySelector('.filters-button-group');
  filtersElem.addEventListener( 'click', function( event ) {
    // only work with buttons
    if ( !event.target.matches('button') ) {
      return;
    }
    var filterValue = event.target.getAttribute('data-filter');
    // use matching filter function
    filterValue = filterFns[ filterValue ] || filterValue;
    iso.arrange({ filter: filterValue });
  });

// change is-checked class on buttons
  var buttonGroups = document.querySelectorAll('.button-group');
  for ( var i=0, len = buttonGroups.length; i < len; i++ ) {
    var buttonGroup = buttonGroups[i];
    radioButtonGroup( buttonGroup );
  }
}

function radioButtonGroup( buttonGroup ) {
  buttonGroup.addEventListener( 'click', function( event ) {
    // only work with buttons
    if ( !event.target.matches('button') ) {
      return;
    }
    buttonGroup.querySelector('.is-checked').classList.remove('is-checked');
    event.target.classList.add('is-checked');
  });
}

</script>

<style scoped>
* { box-sizing: border-box; }

#grid{
  display:flex;
  flex-grow:1;
  flex-direction:column;
  align-items: stretch;
  height:100vh;
  padding-left:50px;
}



#grid > .scroll{
  flex-direction: column;
  overflow-y:auto;
flex:1;
  margin-bottom:2px;
}

.scroll::-webkit-scrollbar-track {
  background: var(--second);
  border: 4px solid var(--darkbg)!important;
  border-radius: 10px;
}

.scroll::-webkit-scrollbar-thumb {
  background: var(--darkbg);
  border: 4px solid var(--second);
}

-webkit-scrollbar:hover{
  cursor:pointer;
}

.scroll::-webkit-scrollbar-thumb:hover {
  background: black;
  border: 4px solid var(--seconddark);
}

.scroll::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background: var(--second);
}


/* ---- isotope ---- */

.grid {
  margin-left:auto;
  margin-right:auto;display:flex;
}

/* clear fix */
.grid:after {
  content: '';
  display: block;
  clear: both;
}

/* ---- .element-item ---- */

.element-item {
  position: relative;
  flex-direction: row;
  width:250px;
  margin:5px;
  height: 200px;
}

.element-item > * {
  margin: 0;
  padding: 0;
}

.element-item .name {
  position: absolute;

  left: 10px;
  top: 60px;
  text-transform: none;
  letter-spacing: 0;
  font-size: 12px;
  font-weight: normal;
}

.element-item .symbol {
  position: absolute;
  left: 10px;
  top: 0px;
  font-size: 42px;
  font-weight: bold;
  color: white;
}

.element-item .number {
  position: absolute;
  right: 8px;
  top: 5px;
}

.element-item .weight {
  position: absolute;
  left: 10px;
  top: 76px;
  font-size: 12px;
}

.grid{
  padding-bottom:40px;
  padding-top:40px;
}
</style>